"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { createPortal } from "react-dom";
import { ExtendedDrop, convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { cicToType, formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MemeDropTraits from "@/components/memes/drops/MemeDropTraits";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface MemesWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const MemesWaveWinnersDrop: React.FC<MemesWaveWinnersDropProps> = t0 => {
  const $ = _c(137);
  const {
    winner,
    wave,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== winner.drop.metadata) {
    t2 = winner.drop.metadata?.find(_temp)?.data_value || "Artwork Title";
    $[2] = winner.drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const title = t2;
  let t3;
  if ($[4] !== winner.drop.metadata) {
    t3 = winner.drop.metadata?.find(_temp2)?.data_value || "This is an artwork submission for The Memes collection.";
    $[4] = winner.drop.metadata;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const description = t3;
  let t4;
  if ($[6] !== winner.drop.parts) {
    t4 = winner.drop.parts.at(0)?.media.at(0);
    $[6] = winner.drop.parts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const artworkMedia = t4;
  const rating = winner.drop.rating || 0;
  const isPositive = rating >= 0;
  const ratersCount = winner.drop.raters_count || 0;
  let creditType;
  let extendedDrop;
  let hasUserVoted;
  let isUserVoteNegative;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let userVote;
  if ($[8] !== artworkMedia || $[9] !== description || $[10] !== hasTouchScreen || $[11] !== isPositive || $[12] !== onDropClick || $[13] !== rating || $[14] !== title || $[15] !== touchHandlers || $[16] !== wave.voting?.credit_type || $[17] !== winner) {
    const topVoters = winner.drop.top_raters?.slice(0, 3) || [];
    creditType = wave.voting?.credit_type || "votes";
    hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context?.rating !== 0;
    userVote = winner.drop.context_profile_context?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    let t18;
    if ($[36] !== winner.drop) {
      t18 = convertApiDropToExtendedDrop(winner.drop);
      $[36] = winner.drop;
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    extendedDrop = t18;
    if ($[38] !== extendedDrop || $[39] !== onDropClick) {
      t16 = () => onDropClick(extendedDrop);
      $[38] = extendedDrop;
      $[39] = onDropClick;
      $[40] = t16;
    } else {
      t16 = $[40];
    }
    t17 = "touch-select-none tw-cursor-pointer tw-rounded-xl tw-transition-all tw-duration-300 tw-ease-out tw-w-full";
    t15 = "tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 desktop-hover:hover:tw-border-[#fbbf24]/40 tw-shadow-[0_0_15px_rgba(251,191,36,0.15)] tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden tw-bg-iron-950";
    t10 = "tw-flex tw-flex-col";
    t11 = touchHandlers;
    const t19 = `/${winner.drop.author?.handle ?? winner.drop.author?.id}`;
    let t20;
    if ($[41] !== winner) {
      t20 = <WaveWinnersDropHeaderAuthorPfp winner={winner} />;
      $[41] = winner;
      $[42] = t20;
    } else {
      t20 = $[42];
    }
    let t21;
    if ($[43] !== t19 || $[44] !== t20) {
      t21 = <Link href={t19} onClick={_temp3} scroll={false} className="tw-flex tw-items-center tw-gap-x-2 tw-no-underline group">{t20}</Link>;
      $[43] = t19;
      $[44] = t20;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    let t22;
    if ($[46] !== winner.drop.author) {
      t22 = winner.drop.author?.level && <UserCICAndLevel level={winner.drop.author.level} cicType={cicToType(winner.drop.author.cic || 0)} size={UserCICAndLevelSize.SMALL} />;
      $[46] = winner.drop.author;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    let t23;
    if ($[48] !== winner.drop.author) {
      t23 = winner.drop.author?.handle ? <UserProfileTooltipWrapper user={winner.drop.author.handle ?? winner.drop.author.id}><Link href={`/${winner.drop.author?.handle ?? winner.drop.author?.id}`} onClick={_temp4} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline desktop-hover:hover:tw-opacity-80 tw-transition-opacity"><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold tw-text-iron-100">{winner.drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${winner.drop.author?.handle ?? winner.drop.author?.id}`} onClick={_temp5} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline desktop-hover:hover:tw-opacity-80 tw-transition-opacity"><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold tw-text-iron-100">{winner.drop.author?.handle}</span></Link>;
      $[48] = winner.drop.author;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    let t24;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
      $[50] = t24;
    } else {
      t24 = $[50];
    }
    let t25;
    if ($[51] !== winner.drop.created_at) {
      t25 = <WaveDropTime timestamp={winner.drop.created_at} />;
      $[51] = winner.drop.created_at;
      $[52] = t25;
    } else {
      t25 = $[52];
    }
    let t26;
    if ($[53] !== t22 || $[54] !== t23 || $[55] !== t25) {
      t26 = <div className="tw-flex tw-items-center tw-gap-x-4"><div className="tw-flex tw-items-center tw-gap-x-2">{t22}{t23}{t24}{t25}</div></div>;
      $[53] = t22;
      $[54] = t23;
      $[55] = t25;
      $[56] = t26;
    } else {
      t26 = $[56];
    }
    let t27;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap tw-bg-[rgba(251,191,36,0.1)] tw-px-2 tw-py-1 tw-border tw-border-solid tw-border-[#fbbf24]/20"><FontAwesomeIcon icon={faTrophy} className="tw-flex-shrink-0 tw-size-3 tw-text-[#fbbf24]" /></div>;
      $[57] = t27;
    } else {
      t27 = $[57];
    }
    let t28;
    if ($[58] !== t21 || $[59] !== t26) {
      t28 = <div className="tw-flex tw-items-center tw-gap-x-3">{t21}{t26}{t27}</div>;
      $[58] = t21;
      $[59] = t26;
      $[60] = t28;
    } else {
      t28 = $[60];
    }
    let t29;
    if ($[61] !== extendedDrop || $[62] !== hasTouchScreen) {
      t29 = !hasTouchScreen && <div className="tw-flex tw-items-center"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
      $[61] = extendedDrop;
      $[62] = hasTouchScreen;
      $[63] = t29;
    } else {
      t29 = $[63];
    }
    let t30;
    if ($[64] !== t28 || $[65] !== t29) {
      t30 = <div className="tw-flex tw-items-center tw-justify-between">{t28}{t29}</div>;
      $[64] = t28;
      $[65] = t29;
      $[66] = t30;
    } else {
      t30 = $[66];
    }
    let t31;
    if ($[67] !== title) {
      t31 = <h3 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-0">{title}</h3>;
      $[67] = title;
      $[68] = t31;
    } else {
      t31 = $[68];
    }
    let t32;
    if ($[69] !== description) {
      t32 = <div className="tw-text-sm tw-text-iron-400">{description}</div>;
      $[69] = description;
      $[70] = t32;
    } else {
      t32 = $[70];
    }
    let t33;
    if ($[71] !== t31 || $[72] !== t32) {
      t33 = <div className="tw-mt-1 sm:tw-mt-0 sm:tw-ml-[3.25rem]">{t31}{t32}</div>;
      $[71] = t31;
      $[72] = t32;
      $[73] = t33;
    } else {
      t33 = $[73];
    }
    if ($[74] !== t30 || $[75] !== t33) {
      t12 = <div className="tw-p-4"><div className="tw-flex tw-flex-col tw-gap-y-1.5">{t30}{t33}</div></div>;
      $[74] = t30;
      $[75] = t33;
      $[76] = t12;
    } else {
      t12 = $[76];
    }
    if ($[77] !== artworkMedia) {
      t13 = artworkMedia && <div className="tw-flex tw-justify-center tw-bg-iron-900/40 tw-h-96"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
      $[77] = artworkMedia;
      $[78] = t13;
    } else {
      t13 = $[78];
    }
    if ($[79] !== winner.drop) {
      t14 = <MemeDropTraits drop={winner.drop} />;
      $[79] = winner.drop;
      $[80] = t14;
    } else {
      t14 = $[80];
    }
    t8 = "tw-flex tw-items-center tw-flex-wrap tw-gap-x-6 tw-gap-y-2 tw-px-4 tw-pt-4 lg:tw-pt-0 tw-pb-4";
    const t34 = `tw-text-sm tw-font-semibold ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"} `;
    let t35;
    if ($[81] !== rating) {
      t35 = formatNumberWithCommas(rating);
      $[81] = rating;
      $[82] = t35;
    } else {
      t35 = $[82];
    }
    let t36;
    if ($[83] !== t34 || $[84] !== t35) {
      t36 = <span className={t34}>{t35}</span>;
      $[83] = t34;
      $[84] = t35;
      $[85] = t36;
    } else {
      t36 = $[85];
    }
    let t37;
    if ($[86] !== creditType) {
      t37 = <span className="tw-text-sm tw-text-iron-400">{creditType}</span>;
      $[86] = creditType;
      $[87] = t37;
    } else {
      t37 = $[87];
    }
    if ($[88] !== t36 || $[89] !== t37) {
      t9 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t36}{t37}</div>;
      $[88] = t36;
      $[89] = t37;
      $[90] = t9;
    } else {
      t9 = $[90];
    }
    t7 = "tw-flex tw-items-center tw-gap-x-2";
    t5 = "tw-flex tw-items-center -tw-space-x-1.5";
    t6 = topVoters.map(_temp7);
    $[8] = artworkMedia;
    $[9] = description;
    $[10] = hasTouchScreen;
    $[11] = isPositive;
    $[12] = onDropClick;
    $[13] = rating;
    $[14] = title;
    $[15] = touchHandlers;
    $[16] = wave.voting?.credit_type;
    $[17] = winner;
    $[18] = creditType;
    $[19] = extendedDrop;
    $[20] = hasUserVoted;
    $[21] = isUserVoteNegative;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = userVote;
  } else {
    creditType = $[18];
    extendedDrop = $[19];
    hasUserVoted = $[20];
    isUserVoteNegative = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t17 = $[29];
    t5 = $[30];
    t6 = $[31];
    t7 = $[32];
    t8 = $[33];
    t9 = $[34];
    userVote = $[35];
  }
  let t18;
  if ($[91] !== t5 || $[92] !== t6) {
    t18 = <div className={t5}>{t6}</div>;
    $[91] = t5;
    $[92] = t6;
    $[93] = t18;
  } else {
    t18 = $[93];
  }
  let t19;
  if ($[94] !== ratersCount) {
    t19 = formatNumberWithCommas(ratersCount);
    $[94] = ratersCount;
    $[95] = t19;
  } else {
    t19 = $[95];
  }
  let t20;
  if ($[96] !== t19) {
    t20 = <span className="tw-text-sm tw-font-medium tw-text-iron-50">{t19}</span>;
    $[96] = t19;
    $[97] = t20;
  } else {
    t20 = $[97];
  }
  const t21 = ratersCount === 1 ? "voter" : "voters";
  let t22;
  if ($[98] !== t21) {
    t22 = <span className="tw-text-sm tw-text-iron-400">{t21}</span>;
    $[98] = t21;
    $[99] = t22;
  } else {
    t22 = $[99];
  }
  let t23;
  if ($[100] !== t20 || $[101] !== t22) {
    t23 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t20}{t22}</div>;
    $[100] = t20;
    $[101] = t22;
    $[102] = t23;
  } else {
    t23 = $[102];
  }
  let t24;
  if ($[103] !== t18 || $[104] !== t23 || $[105] !== t7) {
    t24 = <div className={t7}>{t18}{t23}</div>;
    $[103] = t18;
    $[104] = t23;
    $[105] = t7;
    $[106] = t24;
  } else {
    t24 = $[106];
  }
  let t25;
  if ($[107] !== creditType || $[108] !== hasUserVoted || $[109] !== isUserVoteNegative || $[110] !== userVote) {
    t25 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">Your vote:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{creditType}</span></span></div></div>;
    $[107] = creditType;
    $[108] = hasUserVoted;
    $[109] = isUserVoteNegative;
    $[110] = userVote;
    $[111] = t25;
  } else {
    t25 = $[111];
  }
  let t26;
  if ($[112] !== t24 || $[113] !== t25 || $[114] !== t8 || $[115] !== t9) {
    t26 = <div className={t8}>{t9}{t24}{t25}</div>;
    $[112] = t24;
    $[113] = t25;
    $[114] = t8;
    $[115] = t9;
    $[116] = t26;
  } else {
    t26 = $[116];
  }
  let t27;
  if ($[117] !== extendedDrop || $[118] !== hasTouchScreen || $[119] !== isActive || $[120] !== setIsActive) {
    t27 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[117] = extendedDrop;
    $[118] = hasTouchScreen;
    $[119] = isActive;
    $[120] = setIsActive;
    $[121] = t27;
  } else {
    t27 = $[121];
  }
  let t28;
  if ($[122] !== t10 || $[123] !== t11 || $[124] !== t12 || $[125] !== t13 || $[126] !== t14 || $[127] !== t26 || $[128] !== t27) {
    t28 = <div className={t10} {...t11}>{t12}{t13}{t14}{t26}{t27}</div>;
    $[122] = t10;
    $[123] = t11;
    $[124] = t12;
    $[125] = t13;
    $[126] = t14;
    $[127] = t26;
    $[128] = t27;
    $[129] = t28;
  } else {
    t28 = $[129];
  }
  let t29;
  if ($[130] !== t15 || $[131] !== t28) {
    t29 = <div className={t15}>{t28}</div>;
    $[130] = t15;
    $[131] = t28;
    $[132] = t29;
  } else {
    t29 = $[132];
  }
  let t30;
  if ($[133] !== t16 || $[134] !== t17 || $[135] !== t29) {
    t30 = <div onClick={t16} className={t17}>{t29}</div>;
    $[133] = t16;
    $[134] = t17;
    $[135] = t29;
    $[136] = t30;
  } else {
    t30 = $[136];
  }
  return t30;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(e_1) {
  return e_1.stopPropagation();
}
function _temp6(e_2) {
  return e_2.stopPropagation();
}
function _temp7(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle ?? voter.profile.id}`} onClick={_temp6} scroll={false} className="tw-transition-transform desktop-hover:hover:tw-translate-y-[-2px]" data-tooltip-id={`voter-${voter.profile.handle}-${voter.rating}`}>{voter.profile.pfp ? <img className="tw-size-6 tw-rounded-md tw-ring-2 tw-ring-black tw-object-contain tw-bg-iron-800" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-size-6 tw-rounded-md tw-ring-2 tw-ring-black tw-object-contain tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle}-${voter.rating}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}